import { RolodexEntryJson } from 'types/rolodex/rolodexEntries'
import { parseString } from 'utils/parsingHelpers'

import { GeckoEntryBase } from './geckoEntry'

/**
 * Matterport space entry type
 */
export class GeckoMatterportSpace extends GeckoEntryBase<
  {
    spaceId: string
    displayName: string
  },
  {
    site?: string
    organization?: string
  }
> {
  /**
   * A simple constructor, private so that a more descriptive factory method
   * (which can return undefined) is used instead
   * @param json The raw JSON to create an instance from
   * @private
   */
  private constructor(json: RolodexEntryJson) {
    super(
      json,
      {
        spaceId: parseString(json.data.space_id) ?? '',
        displayName: parseString(json.data.display_name) ?? '',
      },
      {
        site: parseString(json.tags.site),
        organization: parseString(json.tags.organization),
      },
      {}
    )
  }

  /**
   * A simple factory method which creates a Matterport space entry from raw JSON
   * @param json The raw JSON to create an instance from
   * @constructor
   */
  public static CreateFromJSON(json: RolodexEntryJson) {
    return new GeckoMatterportSpace(json)
  }
}
